import axios, { AxiosInstance } from "axios";
import tokenManager from "./tokenManager";
import tokenConstant from "service/constant/tokenConstant";
import routerConstant from "service/constant/routerConstant";

interface ITokenCheck {
  accessToken: string | null;
}

export default class AxiosManager {
  private static instance: AxiosManager | null = null;

  private static axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  public static getInstance(responseType?: any) {
    if (this.instance === null) {
      this.instance = new AxiosManager();
    }
    return this.axiosCustom(tokenManager.getAccessToken(), responseType);
  }

  private static axiosCustom(tokenCheck: ITokenCheck, responseType?: any) {
    this.axiosInstance.interceptors.request.use((config: any) => {
      if (
        config.url !== "/api/auth/producer/token/refresh" &&
        tokenCheck.accessToken
      ) {
        return {
          ...config,
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${tokenCheck.accessToken}`,
            ...config.headers,
          },
          responseType: responseType ? responseType : "json",
        };
      } else {
        return config;
      }
    });

    this.axiosInstance.interceptors.response.use(
      (res) => {
        return res;
      },
      (err) => {
        const originalRequest = err.config;
        if (err.response?.status === 401) {
          const preRefreshToken = localStorage.getItem(
            tokenConstant.REFRESHTOKEN,
          );
          if (preRefreshToken) {
            return this.axiosInstance
              .post("/api/auth/producer/token/refresh", {
                refreshToken: preRefreshToken,
              })
              .then((res) => {
                const { accessToken, refreshToken } = res.data.data;
                localStorage.setItem(tokenConstant.ACCESSTOKEN, accessToken);
                localStorage.setItem(tokenConstant.REFRESHTOKEN, refreshToken);

                originalRequest.headers.Authorization = `Bearer ${accessToken}`;
                return this.axiosInstance(originalRequest);
              })
              .catch(() => {
                localStorage.removeItem(tokenConstant.ACCESSTOKEN);
                localStorage.removeItem(tokenConstant.REFRESHTOKEN);
                window.location.href = "/";
                return false;
              });
          }
          return err;
        }
        return err;
      },
    );

    return this.axiosInstance;
  }
}
